import Vue from 'vue'
import VueRouter from 'vue-router'

import routes from './routes'

Vue.use(VueRouter)


export default function ( /* { store, ssrContext } */ {
  store
}) {
  const Router = new VueRouter({


    srcollBehavior: (to, from, savedPosition) => {
      return {
        x: 0,
        y: 0
      }
      // if (to.hash) {
      //   return {
      //     selector: to.hash
      //   }
      // }
    },
    store,
    routes,
    mode: process.env.VUE_ROUTER_MODE,
    base: process.env.VUE_ROUTER_BASE
  });

  Router.beforeEach((to, from, next) => {
    // cookie 写入

    store.dispatch('LoginEventAction');

    const path = to.path.toLowerCase()
   // store.commit('SET_INTERACT', path === '/interact')
    // store.commit('SET_ROATEUSER', path === '/user')
    store.commit('SET_DOWNLOAD', path === '/download')

    let _obj = {
      PageName: path.slice(1) || 'home'
    }

    store.dispatch('SetUserPvAaction', _obj)

    next();

  })



  return Router
}
